import { useHistory, useLocation } from 'react-router';

import { useIsPreview } from 'shared/hooks/useIsPreview';
import { useDistributionSlug } from 'shared/hooks/useDistributionSlug';
import { compilePath, CompilePathParams } from 'router/compilePath';
import { SurveyRoute } from 'app/route';
import { useRouteQuery } from 'shared/hooks/useRouteQuery';

export const useSurveyNavigation = () => {
  const history = useHistory();
  const { search } = useLocation();

  const isPreview = useIsPreview();
  const distributionSlug = useDistributionSlug();
  const { accessCode, submitId } = useRouteQuery();

  const navigate = (previewPattern: string, surveyPattern: string, params: CompilePathParams) => {
    if (isPreview) {
      // Preserve raw query string to maintain bracket notation (e.g. classifications[]=X)
      // that would be lost when parsed via URLSearchParams and re-serialized.
      const path = compilePath(previewPattern, params);
      history.push(`${path}${search}`);
    } else {
      history.push(compilePath(surveyPattern, params, { accessCode, submitId }));
    }
  };

  const goToWelcomePage = () => {
    navigate(SurveyRoute.PREVIEW_PATTERN, SurveyRoute.SURVEY_PATTERN, { distributionSlug });
  };

  const goToPageNumber = (page: number) => {
    navigate(SurveyRoute.Preview.PAGE_PATTERN, SurveyRoute.Survey.PAGE_PATTERN, {
      distributionSlug,
      page,
    });
  };

  const goToSubmitPage = () => {
    navigate(SurveyRoute.Preview.SUBMIT_PATTERN, SurveyRoute.Survey.SUBMIT_PATTERN, {
      distributionSlug,
    });
  };

  const goToSuccessPage = () => {
    navigate(SurveyRoute.Preview.SUCCESS_PATTERN, SurveyRoute.Survey.SUCCESS_PATTERN, {
      distributionSlug,
    });
  };

  const goToSaveSuccessPage = () => {
    navigate(SurveyRoute.Preview.SAVE_SUCCESS_PATTERN, SurveyRoute.Survey.SAVE_SUCCESS_PATTERN, {
      distributionSlug,
    });
  };

  return {
    goToWelcomePage,
    goToPageNumber,
    goToSubmitPage,
    goToSuccessPage,
    goToSaveSuccessPage,
  };
};
